import { Spinner } from '@agro-club/agroclub-shared'
import { FC, useEffect } from 'react'
import { useSingleEntity } from 'modules/domain/common/hooks'
import { endpoints } from 'modules/endpoints'
import { SampleWithRequests } from '../../types'
import { SampleRequestBlock } from 'views/components/Sample/SampleRequest/SampleRequestBlock'

type Props = {
  bidId: number
  currentSampleId: number
  setSummary: (number) => void
}

export const ExtraInfo: FC<Props> = ({ bidId, currentSampleId, setSummary }) => {
  const [, samples, refetchSamples] = useSingleEntity<SampleWithRequests[]>(endpoints.samplesForBid(bidId as any))

  useEffect(() => {
    if (!samples) return
    let hasExtraInfo = false
    if (samples.length > 1) {
      hasExtraInfo = true
    } else if (samples.length === 1) {
      hasExtraInfo = !!samples[0].sample_requests.length
    }
    setSummary(hasExtraInfo)
  }, [currentSampleId, samples, setSummary])

  if (!samples) {
    return <Spinner />
  }

  return <SampleRequestBlock bidId={bidId} data={samples} refetch={refetchSamples} currentSampleId={currentSampleId} />
}
